import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LoadingModalWrapper = styled("div")(() => ({
  background: "rgba(70, 88, 105, 0.2)",
  display: "flex",
  height: "100vh",
  overflow: "hidden",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const LoadingSpinner = styled(CircularProgress)(() => ({
  color: "#0055A4",
}));
